import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n/i18n';
import { getEquipmentDetails } from '../../../../redux/Slices/EquipmentSlice';


// view equipment component
const ViewEquipment = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setIsLoading(true);
        const payload = await dispatch(getEquipmentDetails(id)).unwrap();
        setDetails(payload?.data || payload);
      } catch (error) {
        toast.error(error || t('equipments.view.messages.fetchError'), { rtl: isRTL });
        navigate('/equipments');
      } finally {
        setIsLoading(false);
      }
    };
    fetchDetails();
  }, [dispatch, id, navigate]);

  if (isLoading) {
    return (
      <div style={{ ...pageStyle, direction: isRTL ? 'rtl' : 'ltr' }}>
        <div style={{ ...cardStyle, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('equipments.view.loading')}</div>
      </div>
    );
  }

  if (!details) {
    return (
      <div style={{ ...pageStyle, direction: isRTL ? 'rtl' : 'ltr' }}>
        <div style={{ ...cardStyle, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('equipments.view.noData')}</div>
      </div>
    );
  }

  return (
    <div style={{ ...pageStyle, direction: isRTL ? 'rtl' : 'ltr' }}>
      <div style={{ ...cardStyle, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, gap: 12, direction: isRTL ? 'rtl' : 'ltr' }}>
          <h2 style={{ margin: 0, fontSize: '20px' }}>{t('equipments.view.title')}</h2>
          <button style={secondaryButtonStyle} onClick={() => navigate('/equipments')}>
            {t('equipments.view.back')}
          </button>
        </div>
        <div style={detailsGrid}>
          {isRTL ? (
            <>
              <InfoRow label={t('equipments.view.nameAr')} value={details.name_ar} isRTL={true} />
              <InfoRow label={t('equipments.view.nameEn')} value={details.name_en} isRTL={true} />
            </>
          ) : (
            <>
              <InfoRow label={t('equipments.view.nameEn')} value={details.name_en} isRTL={false} />
              <InfoRow label={t('equipments.view.nameAr')} value={details.name_ar} isRTL={true} />
            </>
          )}
          <InfoRow label={t('equipments.view.code')} value={details.code} isRTL={isRTL} />
          <InfoRow label={t('equipments.view.quantity', { defaultValue: 'الكمية في المخزون' })} value={details.quantity} isRTL={isRTL} />
          <InfoRow
            label={t('equipments.view.status')} 
            value={details.is_active ? t('equipments.view.active') : t('equipments.view.inactive')} 
            isRTL={isRTL} 
          />
          <InfoRow label={t('equipments.view.notes')} value={details.notes} isRTL={isRTL} />
        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value, isRTL }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
    <span style={{ color: '#888', fontSize: 13 }}>{label}</span>
    <span style={{ fontWeight: 'bold' }}>{value || '—'}</span>
  </div>
);

const pageStyle = {
  padding: 30,
  backgroundColor: '#14263b',
  minHeight: 'calc(100vh - 80px)',
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
};

const cardStyle = {
  width: '100%',
  maxWidth: 700,
  backgroundColor: '#1b3350',
  borderRadius: 12,
  padding: 24,
  border: '1px solid #333',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
};

const detailsGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: 16,
};

const secondaryButtonStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  border: '1px solid #444',
  padding: '10px 18px',
  borderRadius: 8,
  cursor: 'pointer',
};

export default ViewEquipment;

